import type { Timestamp } from 'firebase/firestore'
import type { FirestoreType } from '../firestoreType'

export enum PlannedDeliveryStatus {
  Planned = 'planned',
  CheckAgain = 'checkAgain',
  Approved = 'approved',
  Failed = 'failed',
  Processing = 'processing',
  ParcelCreated = 'parcelCreated',
  Shipped = 'shipped',
}

export type PlannedDelivery = FirestoreType & {
  IsLocked: boolean
  Status: PlannedDeliveryStatus
  ExpectedDeliveryDate: Timestamp
  UserId: string
  IsRushDelivery: boolean
  TicketUrl?: string
  EarliestAuthorisationDate?: Timestamp | null
}
